import React from "react";

export default function Beneficios() {
  const beneficios = [
    {
      icon: "https://sidomsuite.com/wp-content/uploads/2024/09/cloud-1.svg",
      title: "100% Cloud y Usuarios ilimitados",
      description:
        "Acceda a su información  desde cualquier lugar y colabore sin límites con SIDOM. Nuestra plataforma en la nube garantiza flexibilidad y eficiencia para su equipo.",
    },
    {
      icon: "https://sidomsuite.com/wp-content/uploads/2024/09/integrated-1.svg",
      title: "Seguimiento automático y reportes en tiempo real",
      description:
        "Tome el control total de sus operaciones automatizando tareas claves. Potencie la toma de decisiones con el análisis de datos a través de reportes. Visibilidad de principio a fin.",
    },
    {
      icon: "https://sidomsuite.com/wp-content/uploads/2024/09/reports-1.svg",
      title: "Integraciones Comex y ERP",
      description:
        "Optimice sus operaciones con nuestras integraciones. Conecte y gestione todos sus procesos en una sola plataforma eficiente.",
    },
    {
      icon: "https://sidomsuite.com/wp-content/uploads/2024/09/operative-1.svg",
      title: "30% de Reducción de Costos Operativos",
      description:
        "Nuestras soluciones de automatización liberan tiempo y recursos para reasignar a tareas estratégicas. El retorno de Inversión se percibe desde la implementación.",
    },
  ];

  return (
    <div className=" ">
      <div className="container mt-[100px] dark:text-sidom-dark bg-sidom-light  dark:bg-sidom-blue">
        <h2 className="text-sidom-orange text-4xl md:text-5xl font-extrabold text-left mb-[60px]">
          Beneficios
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 mb-[100px]  mt-5 gap-2.5">
          {beneficios.map((beneficio, index) => (
            <div
              key={index}
              className="bg-sidom-blue p-4 dark:bg-sidom-orange h-full rounded-3xl leading-[1.3] shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex flex-col h-full gap-3 p-4">
                <div className="  rounded-full p-2">
                  <div className="bg-sidom-orange dark:bg-sidom-blue flex justify-center items-center rounded-full  w-12 h-12">
                    <img src={beneficio.icon} alt="icono" className="w-8 h-8" />
                  </div>
                </div>
                <div className="flex flex-col justify-start w-[80%] items-start   ">
                  <h2 className=" text-3xl  text-sidom-light font-black ">
                    {beneficio.title}
                  </h2>
                </div>
                <div>
                  <p className=" text-sidom-light   ">
                    {beneficio.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
